import xs from "xstream/index";
import { NEW_BASE_URL } from "../config";
import * as ActionTypes from "../actions/types";
import * as actions from "../actions";
import sampleCombine from "xstream/extra/sampleCombine";
import { generalHeader } from "./headers";
import {
  createBackendRequest,
  getUserIdFromState,
} from "../mappers/backendMappers";

export function fetchApiProducts(sources) {
  const state$ = sources.STATE;
  const csrfToken$ = state$.map((state) => state.applicationUser?.token);
  const userId$ = state$.map((state) => getUserIdFromState(state));

  const request$ = sources.ACTION.filter(
    (action) => action.type === ActionTypes.FETCH_API_PRODUCTS
  )
    .compose(sampleCombine(csrfToken$, userId$))
    .map(([action, csrfToken, userId]) => {
      // Create request body for new backend API with default pagination
      const requestBody = createBackendRequest(
        {
          PageLimit: 50,
          PageOffset: 0,
        },
        userId
      );

      return {
        url: NEW_BASE_URL + "/Product/list",
        category: "fetchApiProducts",
        method: "POST",
        headers: {
          ...generalHeader(csrfToken, true),
          "Content-Type": "application/json",
        },
        send: requestBody,
        // withCredentials: true, // Commented out due to CORS issues
      };
    });

  const httpResponse$ = sources.HTTP.select("fetchApiProducts")
    .map((response) => response.replaceError((err) => xs.of(err)))
    .flatten()
    .filter((response) => response.status === 200)
    .map((response) => {
      // Get products directly from backend
      const payload = response.body?.payload || response.body?.Payload;
      if (response.body && payload) {
        const products = payload.data || payload.Products || payload;
        // Pass backend data directly to reducer without transformation
        return actions.storeApiProducts(products);
      }
      return actions.storeApiProducts([]);
    });

  return {
    ACTION: httpResponse$,
    HTTP: request$,
  };
}

// fetchApiProductNewVersion removed 2026-09-20: called a dead legacy Drupal JSON:API
// endpoint (BASE_URL + /jsonapi/node/api_product) that no longer exists in the new stack,
// so the "GO TO NEW VERSION" banner never rendered. Replaced by client-side resolution
// against the already-fetched product list - see resolveProductFamily.js and
// devportal-manager-cms-feature memory.
